import React from 'react';
import Table from 'react-bootstrap/Table';
import { useNavigate } from "react-router-dom";

function AgencyTable({tableData}) {
  const navigate = useNavigate();
  const handleEditClick=(id)=>{
    //alert(id);
    navigate(`/home/agency/edit/${id}`);
   }
  return (
    <Table striped bordered hover className='tbl-require'>
    <thead>
        <tr>
            <th>#</th>
            <th>Agency Name</th>
            <th>Address</th>
            <th>Company Id</th>
            <th>Email Id</th>
           
            <th style={{textAlign:'center'}}>Action</th>
        </tr>
    </thead>
    <tbody>
    { tableData && tableData.map((details,index)=>(
        <tr key={index}>
            <td>{index+1}</td>
            <td>{details.full_name}</td>
            <td>
                {`${details.address1}, ${details?.state_name}`}
                {/* {details.address1}, {details?.state_name} */}
            </td>
            <td>
                {details.agency_id}
            </td>
            <td>{details.user_email}</td>
           
            <td style={{textAlign:'center',cursor:'pointer'}}>
                <i className="pi pi-pen-to-square icon-btn-edit" onClick={() => handleEditClick(details.user_id)} ></i>
                <i className="pi pi-trash icon-btn-delete"></i>
           </td>
        </tr> 
                )) } 
    </tbody>
</Table>
  )
}

export default AgencyTable